<template>

  <div>

    <Index v-if="activeName == 'index'"></Index>
     <Category v-if="activeName == 'category'"></Category>

    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Index from './index/index';
import Setting from './setting/getSetting';
import Category from './../requirement_type/index/index';


export default {
  components: {
    Index,
    Setting,
    Category,
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'index',
      /*切换数组*/
      sourceList: [
        {
          key: 'index',
          value: '列表',
          path:'/plus/requirement_hall/index/index'
        },
         {
          key: 'category',
          value: '需求分类',
          path:'/plus/requirement_type/index/index'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/requirement_hall/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'activity',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'activity'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/requirement_hall/index.vue